import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import AboutTabs from "./aboutTabs";

const About = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">About Us</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "About" }, { title: breadcrumb }]}
        />
      </div>
      <AboutTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default About;
